import React, { useEffect, useState } from 'react';
import Risk from '../Risk';
import { risksActions } from '../../../../behavior/risks/index';
import { Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';

type Props = {
  conditionToDisplayEnvRiskLevel: boolean;
  values: any;
  envRiskCalculation: number;
  envRiskResultDto: any;
  initialEnvRiskResultDto: any;
  labelPrefix: string;
  isEnvRiskLoading: boolean;
  tooltip: string;
  calculateEnvRiskAction: (arg: any) => void;
};

const EnvironmentalRisk = ({
  conditionToDisplayEnvRiskLevel,
  values,
  envRiskCalculation,
  envRiskResultDto,
  initialEnvRiskResultDto,
  labelPrefix,
  isEnvRiskLoading,
  tooltip,
  calculateEnvRiskAction,
}: Props) => {
  const [displayRisk, setDisplayRisk] = useState(
    !!initialEnvRiskResultDto && !!initialEnvRiskResultDto.envRisk
  );
  const [displayLevel, setDisplayLevel] = useState(
    !!initialEnvRiskResultDto && !!initialEnvRiskResultDto.envRisk
  );

  useEffect(() => {
    if (
      !initialEnvRiskResultDto ||
      (!initialEnvRiskResultDto.envRisk && !initialEnvRiskResultDto.envRiskLevel)
    )
      updateEnvRisk();
  }, [initialEnvRiskResultDto]);

  useEffect(() => {
    updateEnvRisk();
  }, [envRiskCalculation, conditionToDisplayEnvRiskLevel, values]);

  const updateEnvRisk = () => {
    const newDisplayLevel = conditionToDisplayEnvRiskLevel;
    const newDisplayRisk = getConditionToDisplayEnvRisk();

    setDisplayLevel(newDisplayLevel);
    setDisplayRisk(newDisplayRisk);

    if (newDisplayLevel || newDisplayRisk) {
      calculateEnvRisk();
    }
  };

  const getConditionToDisplayEnvRisk = () => {
    const { chemicalProduct, envAttributes } = values;

    const liquidCategoryCondition =
      chemicalProduct && chemicalProduct.liquidCategory && chemicalProduct.liquidCategory.id;

    //required envAttributes fields not checked here are prefilled and always have value
    const envAttributesCondition =
      envAttributes &&
      envAttributes.typePresence &&
      envAttributes.typePresence.id &&
      envAttributes.waterCourse &&
      envAttributes.waterCourse.id;

    return conditionToDisplayEnvRiskLevel && liquidCategoryCondition && envAttributesCondition;
  };

  const calculateEnvRisk = () => {
    const { chemicalProduct, envAttributes, quantity } = values;

    let envRiskRequestDto = { chemicalProduct, envAttributes, quantity };
    calculateEnvRiskAction(envRiskRequestDto);
  };

  let envRiskResult = envRiskResultDto || initialEnvRiskResultDto;
  let value,
    value2,
    levelColor,
    label = '',
    finalTooltip = '';

  if (envRiskResult && envRiskResult.envRiskLevel) {
    value = envRiskResult.envRiskLevel.description;
    levelColor = envRiskResult.envRiskLevel.color;
    if (displayRisk) {
      label = labelPrefix + 'environmental.risk.label.with.value';
      value2 = envRiskResult.envRisk;
    } else if (displayLevel) {
      label = labelPrefix + 'environmental.risk.level.label.with.value';
    }
    finalTooltip = labelPrefix + tooltip;
  }

  return (
    <>
      {isEnvRiskLoading && <Loader active size="tiny" />}
      {!isEnvRiskLoading && (
        <Risk
          id="envRisk"
          label={label}
          value={value}
          value2={value2}
          levelColor={levelColor}
          display={displayRisk || displayLevel}
          tooltip={finalTooltip}
        />
      )}
    </>
  );
};

EnvironmentalRisk.defaultProps = {
  labelPrefix: '',
  tooltip: 'environmental.risk.tooltip',
};

const mapStateToProps = (state: any) => ({
  envRiskCalculation: state.risks.envRiskCalculation,
  isEnvRiskLoading: state.risksResult.isEnvRiskLoading,
  envRiskResultDto: state.risksResult.envRiskResultDto,
});

const mapDispatchToProps = (dispatch: any) => ({
  calculateEnvRiskAction: (envRiskRequestDto: any) =>
    dispatch(risksActions.calculateEnvRisk(envRiskRequestDto)),
  clearEnvRiskCalculationDto: () => dispatch(risksActions.clearEnvRiskCalculationDto()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnvironmentalRisk);
